import { Stack, Grid, SimpleGrid, Paper, Skeleton, Group, Box } from '@mantine/core';
import Card from 'components/Card';

export const StatCardSkeleton = () => (
  <Paper
    withBorder
    p='md'
    radius='lg'
    style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
      border: '1px solid #e9ecef'
    }}
  >
    <Group justify='space-between' align='flex-start'>
      <Stack gap='xs' style={{ flex: 1 }}>
        <Skeleton height={12} width='60%' />
        <Skeleton height={32} width='40%' />
        <Skeleton height={10} width='70%' />
      </Stack>
      <Skeleton height={36} width={36} radius='md' />
    </Group>
  </Paper>
);

export const StatusSummarySkeleton = () => (
  <Card>
    <Stack gap='md'>
      <Skeleton height={24} width='200px' />
      <SimpleGrid cols={{ base: 2, md: 4 }} spacing='md'>
        {Array.from({ length: 4 }).map((_, index) => (
          <Paper key={index} p='md' withBorder radius='md' style={{ backgroundColor: '#fafafa' }}>
            <Group>
              <Skeleton height={28} width={28} radius='sm' />
              <div>
                <Skeleton height={24} width='40px' mb={4} />
                <Skeleton height={14} width='60px' />
              </div>
            </Group>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  </Card>
);

/* eslint-disable */
export const AssessmentTableSkeleton = ({ title }: { title: string }) => (
  <Card>
    <Stack gap='md'>
      <Group justify='space-between' align='center'>
        <Skeleton height={24} width='200px' />
        <Group gap='sm'>
          <Skeleton height={22} width={30} radius='sm' />
          <Skeleton height={28} width={80} radius='sm' />
        </Group>
      </Group>

      {/* Table header skeleton */}
      <Box>
        <Group justify='space-between' p='sm' style={{ borderBottom: '1px solid #e9ecef' }}>
          <Skeleton height={16} width='120px' />
          <Skeleton height={16} width='80px' />
          <Skeleton height={16} width='100px' />
          <Skeleton height={16} width='80px' />
          <Skeleton height={16} width='100px' />
          <Skeleton height={16} width='80px' />
        </Group>

        {/* Table rows skeleton */}
        {Array.from({ length: 3 }).map((_, index) => (
          <Group
            key={index}
            justify='space-between'
            p='sm'
            style={{ borderBottom: '1px solid #f1f3f4' }}
          >
            <Stack gap={4} style={{ flex: 2 }}>
              <Skeleton height={14} width='80%' />
              <Skeleton height={12} width='60%' />
            </Stack>
            <Skeleton height={20} width={60} radius='sm' />
            <Stack gap={4} style={{ flex: 1 }}>
              <Skeleton height={12} width='70%' />
              <Skeleton height={10} width='50%' />
            </Stack>
            <Skeleton height={20} width={70} radius='sm' />
            <Skeleton height={12} width='30px' />
            <Skeleton height={28} width={28} radius='sm' />
          </Group>
        ))}
      </Box>
    </Stack>
  </Card>
);
/* eslint-enable */

export const OverviewSkeleton = () => (
  <Stack gap='xl'>
    <SimpleGrid cols={{ base: 2, sm: 2, md: 4 }} spacing='lg'>
      {Array.from({ length: 4 }).map((_, index) => (
        <StatCardSkeleton key={index} />
      ))}
    </SimpleGrid>

    <StatusSummarySkeleton />

    <Grid>
      <Grid.Col span={12}>
        <AssessmentTableSkeleton title='Active Assessments' />
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        <AssessmentTableSkeleton title='Upcoming Assessments' />
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        <AssessmentTableSkeleton title='Incomplete Assessments' />
      </Grid.Col>

      <Grid.Col span={12}>
        <AssessmentTableSkeleton title='Recent Activity' />
      </Grid.Col>
    </Grid>
  </Stack>
);
